export default [
    {
        name: "driverId",
        label: "Driver",
        type: "relation",
        collection: "drivers",
        fields: ["name", "phoneNumber"],
    },
    {
        name: "truckTypeId",
        label: "Truck Type",
        type: "relation",
        collection: "truck-types",
        fields: ["alias"],
    },
    {
        name: "plateNumber",
        label: "Plate Number",
        type: "string",
    },
    {
        name: "model",
        label: "Truck's Model",
        type: "string",
    },
    {
        name: "truckLicense",
        label: "Truck's License",
        type: "image",
    },
    {
        name: "year",
        label: "Year",
        type: "number",
    },
    {
        name: "photo",
        label: "Truck's Photo",
        type: "image",
    },
];
